import { PaymentRecord, PaymentStats, PaymentFilters } from "../../types/payment.types";
import apiService from "../api/api.service";

class PaymentService {
    private static instance: PaymentService;

    private constructor() { }

    public static getInstance(): PaymentService {
        if (!PaymentService.instance) {
            PaymentService.instance = new PaymentService();
        }
        return PaymentService.instance;
    }

    // Tüm ödeme kayıtlarını getir
    public async getAllPaymentRecords(filters?: PaymentFilters): Promise<PaymentRecord[]> {
        const queryParams = new URLSearchParams();

        if (filters) {
            if (filters.dateRange) {
                queryParams.append('startDate', filters.dateRange[0]);
                queryParams.append('endDate', filters.dateRange[1]);
            }
            if (filters.paymentStatus) queryParams.append('status', filters.paymentStatus);
            if (filters.planType) queryParams.append('type', filters.planType);
            if (filters.companyId) queryParams.append('companyId', filters.companyId.toString());
            if (filters.minAmount) queryParams.append('minAmount', filters.minAmount.toString());
            if (filters.maxAmount) queryParams.append('maxAmount', filters.maxAmount.toString());
        }

        const response = await apiService.get<PaymentRecord[]>(`/payments?${queryParams.toString()}`);
        return response;
    }

    // Ödeme istatistiklerini getir
    public async getPaymentStats(): Promise<PaymentStats> {
        const response = await apiService.get<PaymentStats>("/payments/stats");
        return response;
    }

    // Şirket bazlı ödeme kayıtlarını getir
    public async getCompanyPaymentRecords(companyId: number): Promise<PaymentRecord[]> {
        const response = await apiService.get<PaymentRecord[]>(`/payments/company/${companyId}`);
        return response;
    }

    // Aylık gelir raporunu getir
    public async getMonthlyRevenueReport(year: number): Promise<any[]> {
        const response = await apiService.get<any[]>(`/payments/monthly-report/${year}`);
        return response;
    }

    // En çok ödeme yapan şirketleri getir
    public async getTopPayingCompanies(limit: number = 10): Promise<any[]> {
        const response = await apiService.get<any[]>(`/payments/top-companies?limit=${limit}`);
        return response;
    }

    // Ödeme geçmişini getir (company report için)
    public async getPaymentHistory(): Promise<PaymentRecord[]> {
        const response = await apiService.get<PaymentRecord[]>('/companies/payment-history');
        return response;
    }
}

export default PaymentService.getInstance(); 